__turbopack_context__.v({
  "root": "GridSection-module-scss-module__Moxe8G__root",
});
